module.exports = __webpack_public_path__ + "img/zhishi.46caf413.png";